import { render, staticRenderFns } from "./TopStartups.vue?vue&type=template&id=02eaf838&scoped=true&"
import script from "./TopStartups.vue?vue&type=script&lang=js&"
export * from "./TopStartups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eaf838",
  null
  
)

export default component.exports